import { ServiceDeliveryStatus } from "../../../../../features/Booking-Form/typings/booking-service-administration.types";

export const colorByDeliveryStatus = (deliveryStatus: ServiceDeliveryStatus | null) => {
  switch (deliveryStatus) {
    case ServiceDeliveryStatus.ORDERED:
      return "red";
    case ServiceDeliveryStatus.IN_PROGRESS:
      return "yellow";
    case ServiceDeliveryStatus.READY:
      return "green";
    case null:
      return "grey";
    default:
      return "blue";
  }
};
